import React from 'react'
import {IAllUserProjects, IExpense, IProject, ITimesheet} from "../../../models";
import {MonthNumber} from "../../../constants/MonthNumber";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import {SummaryEmployeesExcelTimesheet} from "./SummaryEmployeesExcelTimesheet";
import {SummaryEmployeesExcelCosts} from "./SummaryEmployeesExcelCosts";
import logo from './../../../assets/html/img/logo.png'
import imageToBase64 from "image-to-base64/browser";

interface ISummaryEmployeesExcelProps {
    chosenTimesheet: ITimesheet
    projects: IProject[]
    users: any
    translate: any
    month?: number
    year?: number
}

const parseMonthFromTimesheet = (chosenTimesheet?: ITimesheet): number | undefined => {
    const date = chosenTimesheet?.date;
    if (!date || date.length < 5) return undefined;
    const m = +(`${date[3]}${date[4]}`);
    return Number.isFinite(m) && m > 0 && m <= 12 ? m : undefined;
};

const parseYearFromTimesheet = (chosenTimesheet?: ITimesheet): number | undefined => {
    const date = chosenTimesheet?.date;
    if (!date || date.length < 8) return undefined;
    const y = +(`20${date[6]}${date[7]}`);
    return Number.isFinite(y) ? y : undefined;
};

export const SummaryEmployeesExcel = async ({
                                                chosenTimesheet,
                                                projects,
                                                users,
                                                translate,
                                                month,
                                                year,
                                            }: ISummaryEmployeesExcelProps) => {

    const effectiveMonth = month ?? parseMonthFromTimesheet(chosenTimesheet) ?? (new Date().getMonth() + 1);
    const effectiveYear = year ?? parseYearFromTimesheet(chosenTimesheet) ?? new Date().getFullYear();

    const today = `${String(new Date().getFullYear()).slice(2, 4)}${(new Date().getMonth() + 1) < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1}${new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()}`
    const documentName = `${today}_Project_Controling_${MonthNumber()[effectiveMonth]?.en_title}`

    const workbook = new ExcelJS.Workbook();
    const worksheetTimesheet = workbook.addWorksheet("Timesheet");
    const worksheetCosts = workbook.addWorksheet("Costs");

    const base64Logo = await imageToBase64(logo) // Path to the image

    const imageId = workbook.addImage({
        base64: base64Logo,
        extension: 'png',
    });
    
    SummaryEmployeesExcelTimesheet({worksheet: worksheetTimesheet, chosenTimesheet, projects, users, translate, logo: imageId, month: effectiveMonth, year: effectiveYear})
    SummaryEmployeesExcelCosts({worksheet: worksheetCosts, chosenTimesheet, projects, users, translate, logo: imageId, month: effectiveMonth, year: effectiveYear})

    workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {type: 'application/octet-stream'});
        FileSaver.saveAs(blob, `${documentName}.xlsx`);
    });


}
